import { GET_LIST } from "actions/Auth/actionTypes";
import { createAction } from "@reduxjs/toolkit";
import { QuestionaireType, SurveyQuestionTopics } from "../constants/enums";
import { uuid } from "uuidv4";
import _ from "lodash";
import { generateUUID } from "utils/appUtil";

export const GET_SURVEY = createAction("getSurvey");
export const GET_SURVEY_LIST = createAction("getSurveyList");
export const GET_SURVEY_ANSWER = createAction("getSurveyAnswer");
export const ADD_SURVEY = createAction("addSurvey");
export const GET_ROLE_LIST = createAction("getRoleList");
export const SET_NO_FOUND = createAction("setNoFound");
export const UPLOAD_MEDIA = createAction<any>("UPLOAD_MEDIA");
export const UPLOAD_CSV = createAction<any>("UPLOAD_CSV");
export const GET_PROJECT_LIST = createAction("getProjectList");
export const GET_ACCOUNT_LIST = createAction("getAccountList");
export const GET_RESPONDER_LIST = createAction("getResponderList");
export const GET_ASSETS_LIST = createAction("getAssetsList");
export const SET_SELECTED_RESPONDER = createAction("setSelectedResponder");
export const SET_SELECTED_ASSETS = createAction("setSelectedAssets");
export const SET_SELECTED_PICKUP = createAction("setSelectedPickup");
export const SET_CURRENT_LOCATION = createAction("setCurrentLocation");
export const SET_CURRENT_PROJECT = createAction("setCurrentProject");
export const SET_SUBMITTED = createAction("setSubmitted");
export const ADD_OTHER_LOCATION = createAction("addOtherLocation");
export const ADD_GEOFENCE_LOCATION = createAction("addGeofenceLocation");
export const ADD_STAND_LOCATION = createAction("addStandLocation");
export const REMOVE_OTHER_LOCATION = createAction("removeOtherLocation");
export const SET_PAGE = createAction("setPage");
export const SET_USERS = createAction("setUsers");
export const SET_MESSAGES = createAction("setMessages");
export const APPEND_MESSAGE = createAction("appendMessage");
export const SET_CURRENT_MESSAGE = createAction("setCurrentMessage");
export const PATCH_PAGE = createAction("patchPage");
export const PATCH_USER = createAction("patchUser");
export const PATCH_USER_STATUS = createAction("patchUserStatus");
export const CLEAR_SUMMARY = createAction("clearSummary");
export const GET_SECTION_LIST = createAction("getSectionList");
export const GET_BIO = createAction("getBio");
export const GET_PROJECT_SURVEY_ID = createAction("getProjectSurveyId");
export const GET_VISIT = createAction<any>("GET_VISIT");
export const GET_STAFF = createAction<any>("GET_STAFF");
export const GET_CALL_LOGS = createAction<any>("GET_CALL_LOGS");
export const GET_AGGREGATE = createAction<any>("GET_AGGREGATE");
export const GET_TICKET_PAGES = createAction<any>("GET_TICKET_PAGES");
export const SET_URL_PARAMS = createAction<any>("SET_URL_PARAMS");
export const GET_MAP_PLACES = createAction("GET_MAP_PLACES");
export const DECRYPT_TOKEN = createAction<any>("decryptToken");
export const GET_HISTORICAL_GPS = createAction("GET_HISTORICAL_GPS");
export const INVOKE_WORKFLOW = createAction<any>("invokeWorkflow");

// call center

export const ACCEPT_RESERVATION = createAction<any>("ACCEPT_RESERVATION");
export const REJECT_RESERVATION = createAction<any>("REJECT_RESERVATION");
export const COMPLETE_TASK = createAction<any>("COMPLETE_TASK");
export const GET_USER_STATUS = createAction<any>("GET_USER_STATUS");
export const UPDATE_USER_STATUS = createAction<any>("UPDATE_USER_STATUS");
export const SAVE_RECORDING = createAction<any>("SAVE_RECORDING");
export const HOLD_CALL = createAction<any>("HOLD_CALL");
export const ADD_PARTICIPANT = createAction<any>("ADD_PARTICIPANT");
export const RECORD_OUTGOING = createAction<any>("RECORD_OUTGOING");

export const initialState: AuthState = {
  survey: {
    _id: uuid(),
    name: "",
    questions: [],
  },
  surveyId: "",
  surveyList: [],
  noFound: false,
  responderAnswers: [],
  rolesList: [],
  fileToSend: null,
  projects: [],
  accounts: [],
  responders: [],
  assets: [],
  selectedResponders: [],
  selectedAssets: [],
  selectedPickup: undefined,
  submitted: false,
  otherLocations: {},
  geofenceLocation: undefined,
  standLocations: [],
  users: [],
  messages: [],
  visit: undefined,
  staff: undefined,
  selectedPage: undefined,
  searchByPhone: undefined,
  sectionList: [
    {
      sectionName: "",
      Rows: [
        {
          isMulti: false,
          Cols: [],
        },
      ],
    },
  ],

  bio: {},
  urlParams: {},
  requestIds: {
    user: generateUUID(),
    log: generateUUID(),
    page: generateUUID(),
  },

  // bio: [{
  //   sectionName: "Basic Bio",
  //   Rows: [
  //     {
  //        isMulti: false,
  //       Cols:  [
  //         {
  //           name: "name",
  //           label: "What is your name?",
  //           type: QuestionaireType.Name,
  //           value: "",
  //           isMulti: false,
  //           options: [],
  //           ColSize: 10,
  //         },
  //         {
  //           name: "email",
  //           label: "What is your email?",
  //           type: QuestionaireType.Email,
  //           value: "",
  //           isMulti: false,
  //           options: [],
  //           ColSize: 10,
  //         },
  //       ],
  //     },
  //     {
  //       isMulti: false,
  //      Cols:  [{
  //       name: "phone",
  //       label: "What is your phone number ?",
  //       type: QuestionaireType.Phone,
  //       value: "",
  //       isMulti: false,
  //       options: [],
  //       ColSize: 10,
  //     },
  //     {
  //       name: "customId",
  //       label: "What is your customId?",
  //       type: QuestionaireType.Text,
  //       value: "",
  //       isMulti: false,
  //       options: [],
  //       ColSize: 10,
  //     },
  //    ]}
  //   ],
  // }],
};

// const getAnswer = (state: any, action: any): any => {
//   return {
//     ...state,
//     survey: action.payload || initialState.responderAnswers,
//   };
// };

const setUrlParams = (state: any, action: any): any => {
  return {
    ...state,
    urlParams: action.payload || initialState.urlParams,
  };
};

const getSectionList = (state: any, action: any): any => {
  return {
    ...state,
    sectionList: action.payload || initialState.sectionList,
  };
};

const getBio = (state: any, action: any): any => {
  return {
    ...state,
    bio: action.payload || initialState.bio,
  };
};

const getRoleList = (state: any, action: any): any => {
  return {
    ...state,
    rolesList: action.payload,
  };
};

const getSurvey = (state: any, action: any): any => {
  return {
    ...state,
    survey: action.payload || initialState.survey,
  };
};

const addSurvey = (state: any, action: any): any => {
  return {
    ...state,
    survey: action.payload,
  };
};

const getSurveyList = (state: any, action: any): any => {
  return {
    ...state,
    surveyList: action.payload || [],
  };
};

const setNoFound = (state: any, action: any): any => {
  return {
    ...state,
    noFound: action.payload || false,
  };
};

const getFileToSend = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    fileToSend: action.payload,
  };
};

const getCSVToSend = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    csvToSend: action.payload,
  };
};

const getProjectList = (state: any, action: any): any => {
  return {
    ...state,
    projects: action.payload || [],
  };
};

const getAccountList = (state: any, action: any): any => {
  return {
    ...state,
    accounts: action.payload || [],
  };
};

const getResponderList = (state: any, action: any): any => {
  return {
    ...state,
    responders: [...(action.payload || [])],
  };
};

const getAssetsList = (state: any, action: any): any => {
  return {
    ...state,
    assets: [...(action.payload || [])],
  };
};

const setSelectedResponder = (state: any, action: any): any => {
  let selected = state.selectedResponders || [];
  let index = selected.findIndex((responder) => {
    return responder.id === action.payload.id;
  });
  if (index === -1) {
    selected.push(action.payload);
  } else {
    selected.splice(index, 1);
  }
  return {
    ...state,
    selectedResponders: selected,
  };
};

const setSelectedAssets = (state: any, action: any): any => {
  let selected = state.selectedAssets || [];
  let index = selected.findIndex((asset) => {
    return asset.id === action.payload.id;
  });
  if (index === -1) {
    selected.push(action.payload);
  } else {
    selected.splice(index, 1);
  }
  return {
    ...state,
    selectedAssets: selected,
  };
};

const setSelectedPickup = (state: any, action: any): any => {
  return {
    ...state,
    selectedPickup: action.payload,
  };
};

const setCurrentLocation = (state: any, action: any): any => {
  return {
    ...state,
    incidentLocation: action.payload || [],
  };
};

const setCurrentProject = (state: any, action: any): any => {
  return {
    ...state,
    project: action.payload,
    responders: action.payload ? state.responders : [],
    selectedResponders: action.payload ? state.selectedResponders : [],
  };
};

const setSubmitted = (state: any, action: any): any => {
  console.log("set submitted here", action.payload);
  const payload = action.payload;
  return {
    ...state,
    submitted: payload,
    responders: !payload || payload.submitted ? [] : state.responders,
    assets: !payload || payload.submitted ? [] : state.assets,
    selectedResponders:
      !payload || payload.submitted ? [] : state.selectedResponders,
    selectedAssets: !payload || payload.submitted ? [] : state.selectedAssets,
    otherLocations: !payload || payload.submitted ? {} : state.otherLocations,
    selectedPickup: undefined,
    geofenceLocation: undefined,
    standLocations: [],
    page: undefined,
  };
};

const patchUser = (state: any, action: any): any => {
  console.log('patch users')
  let users = state.users || [];
  const userIdx = users.findIndex((user) => {
    return user.id === action.payload.userId;
  });
  // console.log("patch user", userIdx, action.payload);
  if (userIdx !== -1) {
    const output = {};
    let current;
    for (let op of action.payload.user) {
      current = output;
      let segments = op.path.split("/");
      segments.map((segment, index) => {
        if (segment !== "") {
          if (!(segment in current)) {
            if (index + 1 === segments.length) {
              current[segment] = op.value;
            } else {
              current[segment] = {};
            }
          }
          current = current[segment];
        }
      });
    }
    users[userIdx] = _.merge(users[userIdx], output);
  }
  return {
    ...state,
    users: [...users],
  };
};

const patchUserStatus = (state: any, action: any): any => {
  console.log("patch user status", action);
  let users = state.users || [];
  const userIdx = users.findIndex((user) => {
    return user.id === action.payload.userId;
  });
  if (userIdx !== -1) {
    users[userIdx].nonpersistent.static.live.status = {
      name: action.payload.status,
      color: action.payload.status,
    };
  }
  return {
    ...state,
    users: [...users],
  };
};

const addOtherLocation = (state: any, action: any): any => {
  return {
    ...state,
    otherLocations: { ...state.otherLocations, ...action.payload },
  };
};

const addGeofenceLocation = (state: any, action: any): any => {
  return {
    ...state,
    geofenceLocation: action.payload,
  };
};

const addStandLocations = (state: any, action: any): any => {
  return {
    ...state,
    standLocations: action.payload,
  };
};

const removeOtherLocation = (state: any, action: any): any => {
  let locations = state.otherLocations;
  delete locations[action.payload];
  return {
    ...state,
    otherLocations: { ...locations },
  };
};

const setUsers = (state: any, action: any): any => {
  return {
    ...state,
    users: action.payload,
  };
};

const setUsersRequest = (state: any, action: any): any => {
  return {
    ...state,
    userRequests: {
      ...state.userRequests,
      [action.payload.id]: action.payload.users,
    },
  };
};

const setSelectedPage = (state: any, action: any): any => {
  return {
    ...state,
    selectedPage: action.payload
  };
};

const setSelectedPhone = (state: any, action: any): any => {
  return {
    ...state,
    searchByPhone: action.payload
  };
};

const processMessage = (
  updatedMessages: Array<any>,
  payload: any
): Array<object> => {
  // const flag = payload.data?.flag;
  const flag = payload.refMessage?.referenceType;
  const originalPageMessageId = payload?.originalPageMessageId;
  if (flag === "update" && !payload.status) {
    let index = updatedMessages.findIndex((x) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages[index] = payload;
  } else if (flag === "remove" && !payload.status) {
    let index = updatedMessages.findIndex((x) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages.splice(index, 1);
  } else updatedMessages.push(payload);
  return updatedMessages;
};

const setMessages = (state: any, action: any): any => {
  let processedMessages = [];
  let allMessages = action.payload;
  allMessages.sort((a, b) =>
    parseInt(a.id) > parseInt(b.id)
      ? 1
      : parseInt(b.id) > parseInt(a.id)
      ? -1
      : 0
  );
  allMessages?.map((message) => {
    processedMessages = processMessage(processedMessages, message);
  });
  return {
    ...state,
    messages: processedMessages,
  };
};

const clearSummary = (state: any, action: any): any => {
  return {
    ...state,
    users: [],
    messages: [],
    page: undefined,
  };
};

const appendMessage = (state: any, action: any): any => {
  const updatedMessages = state.messages || [];
  const flag = action.payload.refMessage?.referenceType;
  const originalPageMessageId = action.payload?.originalPageMessageId;
  if (flag === "update" && !action.payload.status) {
    let index = updatedMessages.findIndex((x: any) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages[index] = action.payload;
  } else if (flag === "remove" && !action.payload.status) {
    let index = updatedMessages.findIndex((x: any) => {
      return (
        x.id === originalPageMessageId ||
        x.originalPageMessageId === originalPageMessageId
      );
    });
    updatedMessages.splice(index, 1);
  } else updatedMessages.push(action.payload);
  return {
    ...state,
    messages: [...updatedMessages],
  };
};

const setCurrentMessage = (state: any, action: any): any => {
  return {
    ...state,
    message: action.payload,
  };
};

const setPage = (state: any, action: any): any => {
  const pages = state.pages || [];
  console.log("pages", pages);
  console.log("update page", action.payload);
  if (pages && pages.length > 0) {
    const index = pages.findIndex((x) => {
      return x.pageId === action.payload.objectId;
    });
    console.log("index", index);
    if (index !== -1) {
      console.log("test index found");
      pages[index] = {
        pageId: action.payload.objectId,
        ...action.payload,
      };
    }
  }
  return {
    ...state,
    page: action.payload,
    pages: [...pages],
  };
};

const patchPage = (state: any, action: any): any => {
  let page = state.page || {};
  console.log("patch page");
  if (page) {
    const output = {};
    let current;
    if (action.payload.length === 0) {
      return {
        ...state,
      };
    }
    for (let op of action.payload) {
      current = output;
      let segments = op.path.split("/");
      segments.map((segment, index) => {
        if (segment !== "") {
          if (!(segment in current)) {
            if (index + 1 === segments.length) {
              current[segment] = op.value;
            } else {
              current[segment] = {};
            }
          }
          current = current[segment];
        }
      });
    }
    console.log("output", output);
    page = _.merge(page, output);
  }
  return {
    ...state,
    page: { ...page },
  };
};

const setAggregateBds = (state: any, action: any): any => {
  return {
    ...state,
    pageAggregateBds: action.payload?.aggregateBds || [],
  };
};

const setPageResult = (state: any, action: any): any => {
  return {
    ...state,
    pages: action.payload || [],
  };
};

const setVisitResult = (state: any, action: any): any => {
  return {
    ...state,
    visit: action.payload || [],
  };
};

const setStaffResult = (state: any, action: any): any => {
  return {
    ...state,
    staff: action.payload || [],
  };
};

const setUserBds = (state: AuthState, action: any): AuthState => {
  let results = action.payload
    .map((x) => {
      return x?.[0];
    })
    .filter((x) => {
      return x !== "cudb-live" && x !== "cudb-root";
    });
  return {
    ...state,
    userBds: results,
  };
};

const setMapAssetsFilter = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    assets_filter: action.payload,
  };
};

const setMapUsersFilter = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    users_filter: action.payload,
  };
};

const setEncryptedToken = (state: AuthState, action: any): AuthState => {
  return {
    ...state,
    encrypted_token: action.payload,
  };
};

const setHistoricalGPS = (state: AuthState, action: any): AuthState => {
  const { response } = action.payload;

  let points = response?.data?.[0]?.samples ?? [];
  points = points.filter((x) => {
    return x.dataset.locationGps !== undefined;
  });
  points.reverse();
  return {
    ...state,
    gps: { points },
  };
};

const authReducer = (
  state: AuthState = initialState,
  action: { payload: any; type: any }
): AuthState => {
  switch (action.type) {
    case GET_PROJECT_SURVEY_ID:
      return {
        ...state,
        surveyId: action.payload,
      };
    case GET_SECTION_LIST:
      return getSectionList(state, action);
    case GET_BIO:
      return getBio(state, action);
    case GET_SURVEY:
      return getSurvey(state, action);
    case ADD_SURVEY:
      return addSurvey(state, action);
    case SET_NO_FOUND:
      return setNoFound(state, action);
    case GET_SURVEY_LIST:
      return getSurveyList(state, action);
    // case GET_SURVEY_ANSWER:
    //     return getAnswer(state, action);
    case GET_ROLE_LIST:
      return getRoleList(state, action);
    case "ADD_FILE":
      return getFileToSend(state, action);
    case "ADD_CSV":
      return getCSVToSend(state, action);
    case GET_PROJECT_LIST:
      return getProjectList(state, action);
    case GET_ACCOUNT_LIST:
      return getAccountList(state, action);
    case GET_RESPONDER_LIST:
      return getResponderList(state, action);
    case GET_ASSETS_LIST:
      return getAssetsList(state, action);
    case SET_SELECTED_RESPONDER:
      return setSelectedResponder(state, action);
    case SET_SELECTED_ASSETS:
      return setSelectedAssets(state, action);
      case SET_SELECTED_PICKUP:
      return setSelectedPickup(state, action);
    case SET_CURRENT_LOCATION:
      return setCurrentLocation(state, action);
    case SET_CURRENT_PROJECT:
      return setCurrentProject(state, action);
    case SET_SUBMITTED:
      return setSubmitted(state, action);
    case SET_URL_PARAMS:
      return setUrlParams(state, action);
    case ADD_OTHER_LOCATION:
      return addOtherLocation(state, action);
    case ADD_GEOFENCE_LOCATION:
      return addGeofenceLocation(state, action);
    case ADD_STAND_LOCATION:
      return addStandLocations(state, action);
    case REMOVE_OTHER_LOCATION:
      return removeOtherLocation(state, action);
    case SET_PAGE:
      return setPage(state, action);
    case PATCH_PAGE:
      return patchPage(state, action);
    case PATCH_USER:
      return patchUser(state, action);
    case PATCH_USER_STATUS:
      return patchUserStatus(state, action);
    case SET_USERS:
      return setUsers(state, action);
    case "SET_USERS_REQUEST_ID":
      return setUsersRequest(state, action);
    case "SET_SELECTED_PAGE":
      return setSelectedPage(state, action);
    case "SEARCH_PAGES_BY_PHONE":
      return setSelectedPhone(state, action);  
    case SET_MESSAGES:
      return setMessages(state, action);
    case APPEND_MESSAGE:
      return appendMessage(state, action);
    case SET_CURRENT_MESSAGE:
      return setCurrentMessage(state, action);
    case CLEAR_SUMMARY:
      return clearSummary(state, action);
    case "USER_BDS":
      return setUserBds(state, action);
    case "AGGREGATE_BDS":
      return setAggregateBds(state, action);
    case "SET_PAGE_RESULT":
      return setPageResult(state, action);
    case "SET_VISIT":
      return setVisitResult(state, action);
    case "SET_STAFF":
      return setStaffResult(state, action);
    case "ADD_MAP_ASSET_FILTER":
      return setMapAssetsFilter(state, action);
    case "ADD_MAP_USER_FILTER":
      return setMapUsersFilter(state, action);
    case "ADD_ENCRYPTED_TOKEN":
      return setEncryptedToken(state, action);
    case "ADD_GPS":
      return setHistoricalGPS(state, action);
    default:
      return state;
  }
};

export default authReducer;
